import microuniversoApi from "app/api/microuniversoApi"
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"


import globalMU from "globalMU"

declare var window:any

export type DefinirCodigoMotivoDescontoItemInput = {
    identificadorItem: number,
    codigoMotivoDesconto: number,
}

export async function DefinirMotivoDescontoItem(input: DefinirCodigoMotivoDescontoItemInput) {
    try {
        globalMU.blockUI({tryPassiveLoading: true})

        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirMotivoDescontoItem(
            input.identificadorItem,
            store.getState().orcamento.IdentificadorOrcamento,
            input.codigoMotivoDesconto
        )

        if ("HasErrors" in orcamentoAtualizado) {
            return
        }

        const atualizarOrcamentoLegado = () => {
            const itemAtualizado = orcamentoAtualizado.ItensOrcamento.find(i => i.Identificador == input.identificadorItem)

            const orcamentoLegado = window.orcamentoController.model
            //const itensLegado = orcamentoLegado.get('ItensOrcamento')
            //const itemLegado = itensLegado.models.find(item => item.get('Identificador') == input.identificadorItem)

            //itemLegado.atualizar(itemAtualizado,false)
            orcamentoLegado.atualizar(orcamentoAtualizado)

        }

        atualizarOrcamentoLegado()
    } finally {
        globalMU.unblockUI()
    }
}
